import { keyframes } from 'styled-components';

// анимация пульсации маркера отеля
export const pulseAnimation = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(0, 122, 255, 1)
  }
  50% {
    box-shadow: 0 0 0 10px rgba(0, 122, 255, 0)
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 122, 255, 0)
  }
`;
